import { useEffect, useState } from "react"
import TableHeader from "../Components/TableHeader"
import core from "../core";
import { Download, ThreeDotsVertical } from "react-bootstrap-icons";
import TableLoader from "../Components/TableLoader";
import OutsideClickHandler from "react-outside-click-handler";
import TableFoot from "../Components/TableFoot";
import axios from "axios";

const ActionsHistory = ({setNotification}) => {
    const query = core.useQuery();
    const [modals, setModals] = useState({});
    const [sortBy, setSortBy] = useState([]);
    const [checkboxes, setCheckboxes] = useState([]);
    const [filter, setFilter] = useState({page: query.page ? query.page : "1", limit: query.limit ? query.limit : 10, keyword: query.keyword ? query.keyword : "", 
        sort_by: query.sort_by ? query.sort_by : "id", sort_order: query.sort_order ? query.sort_order : "DESC", auction: query.auction ? query.auction : "", 
        admin: query.admin ? query.admin : "", start_date: query.start_date ? query.start_date : "", end_date: query.end_date ? query.end_date : ""});
    const [logsHistory, setLogsHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState("");
    const [total, setTotal] = useState(0);

    const handlers = {

    }

    useEffect(() => {
        axios('/api/extension/v1/options?name=bids-sort-by')
            .then((res) => {
                const data = res.data.data;
                setSortBy(typeof data == "string" ? JSON.parse(data) : data);
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, [])

     useEffect(() => {
        setLoading(true);
        axios(`/api/extension/v1/actions-history?page=${filter.page}&limit=${filter.limit}&keyword=${filter.keyword}&sort_by=${filter.sort_by}&sort_order=${filter.sort_order}&auction=${filter.auction}&admin=${filter.admin}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
            .then((res) => {
                const data = res.data.data;
                setLogsHistory(data)
                const count = res.data.total;
                const pageCount = count <= filter.limit ? 1 : (count % filter.limit == 0 ? count / filter.limit : parseInt(count / filter.limit) + 1);
                setTotal(pageCount);
                setLoading(false)
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
                setLoading(false);
            })
     }, [filter])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Actions History</h2>
            <TableHeader setNotification={setNotification} setModals={setModals} filter={filter} withoutAddNew={true} AddNewButtonIcon={Download} sortBy={sortBy} exportButton={false} checkboxes={checkboxes} setFilter={setFilter} />
            <table className="responsive-d-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Lot</th>
                        <th>Username</th>
                        <th>Bidder</th>
                        <th>Date</th>
                        <th>IP Address</th>
                        <th>Auction</th>
                        <th>Action Type</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (!loading && logsHistory.length > 0) && logsHistory.map((logs, id) => {
                            return <tr key={logs.id} className={(id + 2) % 2 == 0 ? "even-row" : "odd-row"}>
                                <td><input type="checkbox" /></td>
                                <td>{logs.lot}</td>
                                <td>{logs.username}</td>
                                <td>{logs.bidder}</td>
                                <td>{core.formdatDate(new Date(logs.action_date), "yyyy-mm-dd hr:min:sec")}</td>
                                <td>{logs.ip_address}</td>
                                <td>{logs.auction}</td>
                                <td>{logs.action_type}</td>
                            </tr>
                        })
                    }
                    {
                        (!loading && logsHistory.length == 0) && <tr style={{background: "#494646ff"}}>
                            <td colSpan={8}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>
                    }
                    {
                        loading && <TableLoader colspan={8}/>
                    }
                </tbody>
            </table>
            <TableFoot  filter={filter} setFilter={setFilter} count={total} />
        </div>
    )
}

export default ActionsHistory